module.exports = __webpack_public_path__ + "img/416.2bf7f502.jpg";